var isDown = false;
var isScaling = false;
var previousTouch = null;
var previousScale = null;
var focused = false;
var draggable;
var pos = {
  x: 0,
  y: 0
}
var zoomTarget = {
  x: 0,
  y: 0
};
var zoomPoint = {
  x: 0,
  y: 0
};
let scale = 1;
var factor = 0.2;
const maxScale = 5;
const minScale = 1;
var minusButton;
var plusButton;
var container;
var collectionButton;

document.addEventListener('DOMContentLoaded', function () {
  draggable = document.querySelector('#draggable-div');
  minusButton = document.querySelector('.minus-button');
  plusButton = document.querySelector('.plus-button');
  container = document.querySelector('#home-main-div');
  collectionButton = document.querySelector('.my-collection-button');
  pos.x = - draggable.offsetWidth * 0.166666;
  pos.y = - draggable.offsetHeight * 0.166666;

  fadeoutZoomHint();

  minusButton.addEventListener('click', zoomOut);
  plusButton.addEventListener('click', zoomIn);
  document.querySelectorAll('.home-album').forEach((element) => {
    element.addEventListener('click', zoomToElement);
  });
  document.querySelectorAll('.album').forEach((element) => {
    element.addEventListener('click', (e) => e.stopPropagation());
  });
  if (collectionButton) {
    collectionButton.addEventListener('click', toggleCollectionAlbums);
  }

  var hammertime = new Hammer(draggable, {});
  hammertime.get('pinch').set({ enable: true });
  hammertime.on('pinch', function (event) {
    console.log(event);
    if (previousScale) {
      factor = (event.scale / previousScale) / 30;
      if (event.scale - previousScale > 0) {
        zoomIn(true);
      } else {
        zoomOut(true);
      }
    }
    previousScale = event.scale;
  });

  document.querySelector('#dropdownSearch').addEventListener('wheel', function (event) {
    event.stopPropagation();
  });
});

document.addEventListener('mousedown', function (event) {
  isDown = true;
});
document.addEventListener('touchstart', function (event) {
  isDown = true;
});

document.addEventListener('mouseup', function (event) {
  isDown = false;
});
document.addEventListener('touchend', function (event) {
  isDown = false;
  previousTouch = null;
  previousScale = null;
  factor = 0.2;
});

document.addEventListener('touchmove', function (event) {
  if (event.touches.length == 1) {
    const touch = event.touches[0];

    if (previousTouch && isDown) {
      const movementX = touch.pageX - previousTouch.pageX;
      const movementY = touch.pageY - previousTouch.pageY;
      const minTranslateX = - (draggable.getBoundingClientRect().width - window.innerWidth);
      const minTranslateY = - (draggable.getBoundingClientRect().height - window.innerHeight);

      pos.x = Math.max(Math.min(0, (pos.x + movementX)), minTranslateX);
      pos.y = Math.max(Math.min(0, (pos.y + movementY)), minTranslateY);
      update(true);
    }

    previousTouch = touch;
  }
});

document.addEventListener('mousemove', function (event) {
  if (focused) {
    return;
  }
  if (isDown) {
    const minTranslateX = - (draggable.getBoundingClientRect().width - window.innerWidth);
    const minTranslateY = - (draggable.getBoundingClientRect().height - window.innerHeight);

    pos.x = Math.max(Math.min(0, (pos.x + event.movementX)), minTranslateX);
    pos.y = Math.max(Math.min(0, (pos.y + event.movementY)), minTranslateY);
    update(true);
  }
});

const throttledZoom =  _.throttle(zoom, 70);

document.addEventListener('wheel', function (event) {

  if (focused) {
    return;
  }

  var delta;
  if (event.deltaY) {
    delta = - event.deltaY;
  } else if (event.originalEvent) {
    delta = event.originalEvent.wheelDelta;
  }
  if (delta === undefined && event.originalEvent) {
    delta = event.originalEvent.detail; // firefox
  }
  if (delta === undefined) {
    return;
  }
  delta = delta > 0 ? 1 : -1; // cap the delta to [-1,1] for cross browser consistency

  throttledZoom(event.pageX, event.pageY, delta)
  // zoom(event.pageX, event.pageY, delta);
});

function unZoomCompletely() {
  scale = 1;
  pos.x = - draggable.offsetWidth * 0.166666;
  pos.y = - draggable.offsetHeight * 0.166666;
  update();
  focused = false;
  draggable.classList.remove('remove-non-focused');
};

function zoomToElement(event) {
  if (scale >= maxScale) {
    if (focused) {
      event.currentTarget.classList.remove('focused');
      unZoomCompletely();
    }
    return;
  }
  scale = maxScale;
  changeAlbumLayouts();
  console.log(event.currentTarget.clientHeight);
  pos.x = - event.currentTarget.offsetLeft * scale + window.innerWidth / 2;
  pos.y = - event.currentTarget.offsetTop * maxScale + event.currentTarget.clientHeight * maxScale + 150;
  update();
  focused = true;
  event.currentTarget.classList.add('focused');
  draggable.classList.add('remove-non-focused');
}


function zoom(pageX, pageY, delta, withoutTransition) {
  // determine the point on where the slide is zoomed in
  if (scale <= 1 && delta < 0 || scale >= maxScale && delta > 0)
    return;

  const zoom = 1 * delta * factor;

  // compute the weights for x and y
  const wx = (pageX - pos.x) / (draggable.clientWidth * scale);
  const wy = (pageY - pos.y) / (draggable.clientHeight * scale);

  // apply the change in x,y and zoom.
  pos.x -= wx * draggable.clientWidth * zoom;
  pos.y -= wy * draggable.clientHeight * zoom;

  // apply zoom
  scale += zoom;
  scale = Math.max(minScale, Math.min(maxScale, scale));

  // Make sure the slide stays in its container area when zooming out
  const minTranslateX = - (draggable.getBoundingClientRect().width - window.innerWidth);
  const minTranslateY = - (draggable.getBoundingClientRect().height - window.innerHeight);

  pos.x = Math.max(Math.min(0, pos.x), minTranslateX);
  pos.y = Math.max(Math.min(0, pos.y), minTranslateY);

  update(withoutTransition);
}

function zoomIn(withoutTransition) {
  if (focused) {
    return;
  }
  zoom(window.innerWidth / 2, window.innerHeight / 2, 1, withoutTransition);
}

function zoomOut(withoutTransition) {
  if (focused) {
    return;
  }
  zoom(window.innerWidth / 2, window.innerHeight / 2, -1, withoutTransition);
}

function update(withoutTransition) {
  if (!withoutTransition) {
    draggable.style.transition = 'transform .30s';
    setTimeout(function () {
      draggable.style.transition = 'none';
    }, 400);
  }
  draggable.style.transform = 'translate(' + pos.x + 'px,' + pos.y + 'px) scale(' + scale + ',' + scale + ')';
  resetButtons();
  changeAlbumLayouts();
}

function resetButtons() {
  minusButton.disabled = (scale == 1);
  plusButton.disabled = (scale == maxScale);
}

function changeAlbumLayouts() {
  console.log(scale);
  if (scale < 3.5) {
    initCollectionLayout();
  // } else if (scale < 3.5) {
  //   initCollectionDetailsLayout();
  } else {
    initArtistLayout();
  }
}

function initCollectionLayout() {
  draggable.classList.add('scale-1');
  draggable.classList.remove('scale-2', 'scale-3');
}

function initArtistLayout() {
  draggable.classList.add('scale-3');
  draggable.classList.remove('scale-1', 'scale-2');
}

function initCollectionDetailsLayout() {
  draggable.classList.add('scale-2');
  draggable.classList.remove('scale-1', 'scale-3');
}

function fadeoutZoomHint() {
  setTimeout(function () {
    const zoomHint = document.querySelector('.zoom-hint');
    zoomHint.classList.add('fade');
    setTimeout(function () {
      zoomHint.classList.remove('d-flex');
      zoomHint.classList.add('d-none');
    }, 3000);
  }, 4000);
}

function toggleCollectionAlbums(event) {
  collectionButton.classList.toggle('activated');
  document.querySelectorAll('.album:not(.in-collection)').forEach((element) => {
    element.classList.toggle('show');
  });
}

new Vue({
  el: '#home-main-div',
  delimiters: ['<%', '%>'],
  data() {
    const years = [];
    const currentYear = moment().year();
    for (let i = 0; i < 6; i++) {
      years.push(currentYear - i);
    }
    return {
      calendarActivated: false,
      years: years,
      selectedYears: [],
    };
  },
  methods: {
    toggleCalendar() {
      this.calendarActivated = !this.calendarActivated;
    },
    isActive(year) {
      return !this.calendarActivated || !this.selectedYears.length || this.isSelected(year) || this.years.length === this.selectedYears.length;
    },
    isSelected(year) {
      return _.includes(this.selectedYears, year);
    },
    selectYear(year) {
      if (this.isSelected(year)) {
        const index = _.findIndex(this.selectedYears, (y) => y === year);
        this.selectedYears.splice(index, 1);
      } else {
        this.selectedYears.push(year);
      }
    }
  }
})